module.exports = __webpack_public_path__ + "img/delivery_gray.42a3f953.svg";